import { createContext, useState } from "react";

export const EncryptionContext = createContext();

export function EncryptionContextProvider({ children }) {
  const [passphrase, setPassphrase] = useState(localStorage.getItem("passphrase") || "");

  return (
    <EncryptionContext.Provider value={{ passphrase, setPassphrase }}>
      {children}
    </EncryptionContext.Provider>
  );
}